var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.76909 16.9555L6.90282 13.8218C6.6994 13.2527 6.58868 12.6399 6.58868 12.0013C6.58868 9.01174 9.01172 6.59129 11.9987 6.59129C12.6373 6.59129 13.2501 6.70202 13.8192 6.90544L15.959 4.76564C14.7102 4.37167 13.3789 4.16052 12.0013 4.16052C6.70715 4.16052 2.14431 7.28138 0.0482807 11.785C-0.0160936 11.9215 -0.0160936 12.0811 0.0482807 12.2202C0.91087 14.0716 2.19063 15.6912 3.76909 16.9555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2309 7.047L17.0972 10.1807C17.3006 10.7498 17.4113 11.3626 17.4113 12.0012C17.4113 14.9908 14.9883 17.4112 12.0013 17.4112C11.3627 17.4112 10.7499 17.3005 10.1808 17.0971L8.04102 19.2369C9.28988 19.6309 10.6211 19.842 11.9987 19.842C17.2929 19.842 21.8557 16.7212 23.9517 12.2175C24.0161 12.0811 24.0161 11.9214 23.9517 11.7824C23.0891 9.93096 21.8094 8.31131 20.2309 7.047Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.001 15.4646C13.9143 15.4646 15.4644 13.9145 15.4644 12.0013C15.4644 11.9421 15.4618 11.8803 15.4592 11.821L11.8208 15.4595C11.88 15.4621 11.9392 15.4646 12.001 15.4646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0014 8.54053C10.0882 8.54053 8.53809 10.0907 8.53809 12.0039C8.53809 12.0631 8.54066 12.1249 8.54324 12.1841L12.1817 8.54568C12.1199 8.54053 12.0606 8.54053 12.0014 8.54053Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60602 17.5735L2.97864 19.2009C2.47652 19.703 2.47652 20.5193 2.97864 21.0214C3.23099 21.2738 3.56058 21.3974 3.89018 21.3974C4.21978 21.3974 4.54937 21.2712 4.80172 21.0214L6.97499 18.8481L9.19462 16.6285L10.6392 15.184L15.1866 10.6366L16.6312 9.19198L19.3967 6.42649L21.024 4.79911C21.5261 4.29699 21.5261 3.48073 21.024 2.97861C20.7717 2.72626 20.4421 2.60266 20.1125 2.60266C19.7829 2.60266 19.4533 2.72883 19.201 2.97861L17.0277 5.15188L14.8081 7.3715L13.3635 8.81606L8.81612 13.3635L7.37156 14.808L4.60602 17.5735Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOff);
export default __webpack_public_path__ + "static/media/visibility-off.7207e1cece47852df9044bb4a6011069.svg";
export { ForwardRef as ReactComponent };